module.exports = __webpack_public_path__ + "img/lzy.164c8b57.png";